export const xIcon = () => (
  <svg fill='none' height='24' width='24' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#a)'>
      <g clipPath='url(#b)'>
        <path
          d='M13.31 11.046 20.383 3h-1.676l-6.145 6.985L7.658 3H2l7.418 10.563L2 22h1.676l6.485-7.378L15.341 22H21M4.28 4.236h2.575l11.852 16.588h-2.575'
          fill='currentColor'
        />
      </g>
    </g>
    <defs>
      <clipPath id='a'>
        <path d='M0 0h24v24H0z' fill='currentColor' />
      </clipPath>
      <clipPath id='b'>
        <path d='M2 3h19v19H2z' fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
